import { useCallback } from 'react';
import { CanvasElementType, CanvasMode, CanvasSection } from '../canvas-types';
import { RfNodeSection } from '../canvas-types/nodeTypesData';
import { useHandleDeleteSection } from '../sections/useHandleDeleteSection';
import { useSweepCanvasPropsCtx } from '../internal-context/SweepCanvasPropsCtx';
import { NODE_Z_INDEX_SECTION } from '../const/zIndex';

const emptySectionNodes: RfNodeSection[] = [];

export const useSectionNodesFactory = () => {
  const { handleDeleteSection } = useHandleDeleteSection();
  const { readonly, canvasMode } = useSweepCanvasPropsCtx();
  const createFlowNodesFromSweepSections = useCallback(
    ({ sections }: { sections?: CanvasSection[] }): RfNodeSection[] => {
      const hideToolbar = [CanvasMode.PREVIEW1, CanvasMode.PREVIEW2, CanvasMode.PREVIEW3].includes(
        canvasMode ?? CanvasMode.DEFAULT,
      );
      if (!sections) {
        return emptySectionNodes;
      }

      const nodes: RfNodeSection[] = [];

      sections?.forEach((section) => {
        nodes.push({
          id: section.id,
          type: CanvasElementType.SECTION,
          data: {
            name: section.name,
            color: section.color,
            onDeleteClick: handleDeleteSection,
            readonly: Boolean(readonly),
            hideToolbar,
          },
          position: section.xyPosition,
          width: section.width,
          height: section.height,
          zIndex: NODE_Z_INDEX_SECTION,
        });
      });

      return nodes;
    },
    [canvasMode, handleDeleteSection, readonly],
  );

  return {
    createFlowNodesFromSweepSections,
  };
};
